import React from 'react';
import { Image, ImageSourcePropType, StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';

import Text from '../global/Text';

export type QuestionnaireAttachmentButtonProps = {
  iconSource: ImageSourcePropType;
  label: string;
  onPress?: () => void;
  disabled?: boolean;
  invalid?: boolean;
  testID?: string;
  accessibilityLabel?: string;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
};

const QuestionnaireAttachmentButton = (props: QuestionnaireAttachmentButtonProps) => {
  const { accessibilityLabel, containerStyle, disabled, iconSource, invalid, label, onPress, style, testID } = props;

  const content = (
    <View
      style={[
        styles.card,
        disabled ? styles.cardDisabled : styles.cardActive,
        invalid ? styles.invalid : null,
        containerStyle
      ]}
    >
      <View style={styles.iconSlot}>
        <Image source={iconSource} style={[styles.icon, disabled ? styles.iconDisabled : null]} resizeMode="contain" />
      </View>
      <Text allowFontScaling={false} style={[styles.label, disabled ? styles.labelDisabled : styles.labelActive]}>
        {label}
      </Text>
    </View>
  );

  if (!onPress) {
    return (
      <View style={style} testID={testID}>
        {content}
      </View>
    );
  }

  return (
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel || label}
      accessibilityState={{ disabled: !!disabled }}
      activeOpacity={0.82}
      disabled={disabled}
      onPress={onPress}
      style={style}
      testID={testID}
    >
      {content}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 96,
    minHeight: 108,
    paddingVertical: 14,
    paddingHorizontal: 12,
    marginVertical: 10,
    marginHorizontal: 6,
    borderRadius: 12,
    borderWidth: 1
  },
  cardActive: {
    borderColor: '#D0D5DD',
    backgroundColor: '#FFFFFF'
  },
  cardDisabled: {
    borderColor: '#EAECF0',
    backgroundColor: '#F9FAFB'
  },
  invalid: {
    borderColor: '#FF6F00'
  },
  iconSlot: {
    width: 30,
    height: 30,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8
  },
  icon: {
    width: '100%',
    height: '100%'
  },
  iconDisabled: {
    opacity: 0.65
  },
  label: {
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 18,
    minHeight: 36
  },
  labelActive: {
    color: '#344054'
  },
  labelDisabled: {
    color: '#98A2B3'
  }
});

export default QuestionnaireAttachmentButton;
